import React from 'react';
import { Switch } from '@headlessui/react';
import { clsx } from 'clsx';

export type DisplayMode = 'cumulative' | 'discrete';

type Props = {
  displayMode: DisplayMode;
  setDisplayMode: (mode: DisplayMode) => void;
};

export function DisplayModeSelector({ displayMode, setDisplayMode }: Props) {
  const isCumulative = displayMode === 'cumulative';

  const handleChange = (checked: boolean) => {
    setDisplayMode(checked ? 'cumulative' : 'discrete');
  };

  return (
    <div className="flex items-center">
      <div className="flex items-center">
        <span className="mr-2 text-sm">Cumulative</span>
        <Switch
          checked={isCumulative}
          onChange={handleChange}
          className={clsx(
            'group relative inline-flex h-6 w-11 items-center rounded-full transition-colors',
            isCumulative ? 'bg-blue-600' : 'bg-gray-200'
          )}>
          <span className="group-data-checked:translate-x-6 h-4 w-4 translate-x-1 transform rounded-full bg-white transition-transform" />
        </Switch>
      </div>
    </div>
  );
}
